import React, { Component } from 'react';
import SweetAlert from 'sweetalert-react';
import { toast, Slide } from 'react-toastify';

class CustomeSweetAlert extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Title: this.props.Title,
            Show: this.props.Show,
            Text: this.props.Text,
            ShowCancelButton: this.props.ShowCancelButton,
            ToastMessage: this.props.ToastMessage,
            ToastAlertType: this.props.ToastAlertType
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        this.setState({
            Title: newProps.Title,
            Show: newProps.Show,
            Text: newProps.Text,
            ShowCancelButton: newProps.ShowCancelButton,
            ToastMessage: newProps.ToastMessage,
            ToastAlertType: newProps.ToastAlertType
        });
    }

    show_toastId() {
        this.toastId = toast(this.state.ToastMessage, {
            transition: Slide,
            closeButton: true,
            autoClose: 5000,
            position: 'bottom-center',
            type: this.state.ToastAlertType,
        });
    }

    render() {
        return (
            <SweetAlert
                confirmButtonColor=""
                title={this.state.Title}
                show={this.state.Show}
                text={this.state.Text}
                showCancelButton={this.state.ShowCancelButton}
                showConfirmButton={this.state.ShowConfirmButton}
                onConfirm={() => {
                    this.props.OnConfirm();
                }}
                onCancel={this.props.OnCancel}
            />
        )
    }
}

export default CustomeSweetAlert;